import { io } from 'socket.io-client';

export function getAuthToken() {
  return localStorage.getItem('neon_token') || localStorage.getItem('token') || '';
}

export function createStaffSocket() {
  const baseUrl = import.meta.env.VITE_API_URL || window.location.origin;
  return io(`${baseUrl}/staff`, {
    path: '/socket.io',
    auth: { token: getAuthToken() },
    transports: ['polling'],
    upgrade: false,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 30000
  });
}
